'use client'

import { Input } from '@/components/ui/input'
import { FieldShell, premiumControlClass } from './field-shell'
import type { AnswerableFieldProps } from './types'

export function EmailField({ props, mode, value, onChange, error }: AnswerableFieldProps<'Email', string>) {
  const isPreview = mode === 'preview'
  return (
    <FieldShell
      mode={mode}
      htmlFor={props.id}
      label={props.label}
      required={props.required}
      helpText={props.helpText}
      error={error}
      conditional={Boolean(props.showIf)}
    >
      <Input
        id={props.id}
        type="email"
        className={premiumControlClass}
        placeholder="name@example.com"
        readOnly={isPreview}
        value={isPreview ? '' : typeof value === 'string' ? value : ''}
        onChange={isPreview ? undefined : e => onChange?.(e.target.value)}
      />
    </FieldShell>
  )
}
